import React, { useEffect, useState } from 'react';
import API from '../../../Utils/api';
import { useNavigate, useParams } from 'react-router';
import { useUser } from '../../../Context/useUser';
import { useVisitingUser } from '../../../Hooks/useVisitingUser';
import { FaUsers, FaChevronRight } from 'react-icons/fa';
import styles from './DashboardPage.module.css';

export default function GroupsList() {
    const { user } = useUser();
    const { coachId } = useParams();
    const visitingCoach = useVisitingUser(coachId);
    // Use visitingCoach if admin is viewing a coach's dashboard, otherwise use logged-in user
    const currentCoach = coachId ? visitingCoach : user;
    const [groups, setGroups] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!currentCoach) return;
        console.log('Fetching groups for coach:', currentCoach._id);
        API.getMyGroups(currentCoach._id)
            .then(({ data }) => {
                console.log('Groups response:', data);
                setGroups(data);
            })
            .catch(err => {
                console.error('Error fetching groups:', err);
                setGroups([]);
            });
    }, [currentCoach]);

    const handleGroupClick = (groupId) => {
        // If viewing another coach's dashboard, navigate to their groups page
        if (coachId) {
            navigate(`/coach/${coachId}/groups`);
        } else {
            navigate('/groups');
        }
    };

    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <div className={styles.sectionTitle}>
                    <FaUsers className={styles.sectionIcon} />
                    <h3>Groups</h3>
                </div>
                <span className={styles.badge}>{groups.length}</span>
            </div>
            <div className={styles.cardsGrid}>
                {groups.length === 0 ? (
                    <div className={styles.emptyState + ' island'}>
                        <FaUsers size={48} className={styles.emptyIcon} />
                        <p>No groups found.</p>
                        <small>Create groups to organize your athletes</small>
                    </div>
                ) : (
                    groups.map(group => (
                        <div
                            key={group._id}
                            className={styles.card + ' island'}
                            onClick={() => handleGroupClick(group._id)}
                        >
                            <div className={styles.cardHeader}>
                                <FaUsers className={styles.cardIcon} />
                                <FaChevronRight className={styles.cardArrow} />
                            </div>
                            <div className={styles.cardContent}>
                                <h4 className={styles.cardTitle}>{group.name}</h4>
                                <p className={styles.cardDescription}>{group.description || 'No description'}</p>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
